import React, { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import api from '../../../seller-apis/api';
import { fetchAllNotifications } from '../../../seller-apis/apidataField';
import moment from "moment";
import Pagination from '../PaginationComponent/index';
import { useDispatch, useSelector } from "react-redux";
import { Actions } from "../../../Actions/Actions";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

var dateFromWeb = moment().subtract(15, 'days').format('YYYY-MM-DD');
var dateToWeb = moment().format('YYYY-MM-DD');

function TransferPriceTab({ onCountUpdate, refreshTrigger, onNotificationClosed, refreshGlobalCount,onClose }) {
  let history = useHistory();
  const [notificationsList, setNotificationsList] = useState([]);
  const [currPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [processingId, setProcessingId] = useState(null);

  const dispatch = useDispatch();
  const itemsPerPage = 5;
  
  const globalFilter = {
    pageNo: currPage,
    size: itemsPerPage,
    filters: {
      type: { $in: ["PRC_CHANGED"] },
      "from-createdAt": dateFromWeb + 'T00:00:00.000Z',
      "to-createdAt": dateToWeb + 'T23:59:59.000Z',
      opened: false
    },
  }; 

  // ✅ ADDED: Watch for refreshTrigger changes
  useEffect(() => {
    console.log('TransferPriceTab: refreshTrigger changed:', refreshTrigger);
    fetchNotifications();
  }, [refreshTrigger, currPage]);
 

  const fetchNotifications = () => {
    console.log('TransferPriceTab: Fetching notifications for page:', currPage);
    
    api.notify.fetchTransferPriceNotifications(fetchAllNotifications({ ...globalFilter, pageNo: currPage }))
      .then(res => {
        console.log('TransferPriceTab: Received data:', res.totalRecords, 'records');
        setNotificationsList(res.data);
        setTotalRecords(res.totalRecords);
        
        // ✅ Always update count (not just on page 1)
        onCountUpdate(res.totalRecords);

        const countData = {
          pageNo: 1,
          size: 1,
          filters: {
            type: { $in: ["PRC_CHANGED"] },
            opened: false,
            "from-createdAt": dateFromWeb + 'T00:00:00.000Z',
            "to-createdAt": dateToWeb + 'T23:59:59.000Z'
          },
        };
        
        // api.notify
        //   .fetchNotifications(fetchAllNotifications(countData))
        //   .then((res) => {
        //     Actions.updateNotificationCount(dispatch, res.totalRecords);
        //   })
        //   .catch((err) => console.log(err));
      })
      .catch(err => console.log(err));
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const formatDate = (dateString) => {
    let date = new Date(dateString);
    return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
  };

  const getCombination = (item) => {
    let cmb = "";
    if (item.productDetails && item.productDetails.value) {
      item.productDetails.value.forEach((litem, lindex) => {
        cmb = cmb + litem;
        if (lindex !== item.productDetails.value.length - 1) {
          cmb = cmb + " x ";
        }
      });
    }
    return cmb;
  };

  const handleVerifyTransferPrice = async (item) => {
    try {
      setProcessingId(item._id);
      
      await api.notify.closeVendorPriceNotification({
        productId: String(item._id),
        vendorId: String(item.vendor),
        combinationUrl: item.url,
        source: item.source,
        vpriceReqId: item.vpriceReqId ? String(item.vpriceReqId) : undefined,
      });
      
      // ✅ Remove from local list
      setNotificationsList(prevList => prevList.filter(notification => notification._id !== item._id));
      const newTotal = totalRecords - 1;
      setTotalRecords(newTotal);
      
      // ✅ Update count immediately
      onCountUpdate(Math.max(0, newTotal));
      
      // ✅ Notify parent to refresh other tabs
      if (onNotificationClosed) {
        onNotificationClosed();
      }
      
      if (refreshGlobalCount) {
        refreshGlobalCount();
      }

      // ✅ Determine URL based on product type
      let url;
      
      // Check if it's a combination product (has combination price notifications)
      if (item.hasCombinationPriceNotification && item.allCombinations && item.allCombinations.length > 0) {
        // Find the first combination with price change
        const combinationWithPriceChange = item.allCombinations.find(
          comb => comb.notificationStatusPrice === true
        );
        
        if (combinationWithPriceChange && combinationWithPriceChange.url) {
          // Combination product URL
          url = `/productDetConf/${item._id}?url=${combinationWithPriceChange.url}`;
        } else {
          // Fallback to standard product
          url = `/productDetail/${item._id}/approv`;
        }
      } else {
        // Standard product (main price notification)
        url = `/productDetail/${item._id}/approv`;
      }
      
      window.open(url, '_blank');
      
    } catch (error) {
      console.error('Error closing notification:', error);
      alert('Failed to close notification. Please try again.');
      // ✅ Refresh on error
      fetchNotifications();
    } finally {
      setProcessingId(null);
    }
  };

  return (
    <>
      {notificationsList && notificationsList.map((item, index) => {
        const cmb = getCombination(item);
        const isProcessing = processingId === item._id;
        
        return (
          <div key={index} className="pn-card">
            <div className="pn-card-row">
              <div className="pn-img-col">
                {item.productDetails && item.productDetails.images && item.productDetails.images.map((img, imgIndex) => {
                  if (img.baseImage) {
                    return (
                      <img 
                        key={imgIndex}
                        className='pn-product-img'
                        src={`https://s3.toolsvilla.com/${img.image}`}
                        alt="product" 
                      />
                    );
                  }
                  return null;
                })}
              </div>
              <div className="pn-content-col">
                <div className="pn-card-content">
                  <div className="pn-title-row">
                    <h6 className="pn-product-title">
                      {item.productDetails && item.productDetails.productName}
                    </h6>
                    <span className="pn-date">{formatDate(item.createdAt)}</span>
                  </div>

                  {cmb && (
                    <span className="pn-combination-badge">
                      {cmb}
                    </span>
                  )}

                  <p className="pn-notes">{item.notes}</p>

                  <button 
                    className={`pn-action-btn ${isProcessing ? 'pn-disabled' : ''}`}
                    onClick={() => handleVerifyTransferPrice(item)}
                    disabled={isProcessing}
                  >
                    {isProcessing ? 'Processing...' : 'Verify Transfer Price'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        );
      })}

      {notificationsList && notificationsList.length === 0 && (
        <div className="pn-empty-state">
          <h6 className="pn-empty-title">No Notifications</h6>
        </div>
      )}
      {totalRecords > itemsPerPage && (
        <div className="transfer_price_tab_view_more">
          <button onClick={() => {
            onClose()
            history.push('/my-inventory/approved/actionrequired')
          }}>View all</button>
        </div>
      )}
    </>
  );
}

export default TransferPriceTab;